import React, { useContext, createContext, useState } from "react";

// Notes. This context will be handling priceData object to be returned from the
// cloud functions.

const Context = createContext(null);

const AppDataProvider = ({ children }) => {
  const [contextState, setContextState] = useState(null);

  const contextData = {
    contextState,
    setContextState,
  };

  return <Context.Provider value={contextData}> {children}</Context.Provider>;
};

function useAppContext() {
  const contextData = useContext(Context);

  if (contextData === undefined) {
    throw new Error("UseAppContext Error");
  }
  return contextData;
}

export { useAppContext, AppDataProvider };
